/**
 * MESSAGE POPUP REDUX REDUCERS
 *
 * @version 0.1
 */


import {
    SET_MESSAGES,
    REMOVE_MESSAGE,
    CLEAR_MESSAGES,
    APPEND_MESSAGES
} from './MessagePopup.actions';

function popupMessages(state = {}, action) {

    switch (action.type) {

        case SET_MESSAGES:
        {
            let popupTitle;
            if (typeof action.payload.popupTitle === 'string' || action.payload.popupTitle === null) {
                popupTitle = action.payload.popupTitle;
            } else {
                popupTitle = state.popupTitle;
            }

            let count = state.popupCount + 1;

            return {
                popupTitle:   popupTitle,
                messages:     [...action.payload.messages],
                popupCount:   count
            };
        }

        case APPEND_MESSAGES:
            return {
                popupTitle:   state.popupTitle,
                messages:     [...state.messages, ...action.payload]
            };

        case REMOVE_MESSAGE:
            let count = state.popupCount - 1;
            if (count < 0) {
                count = 0;
            }
            let messages = [];
            if (count > 0) {
                messages = state.messages;
            }
            return {
                popupTitle:   state.popupTitle,
                messages:     messages,
                popupCount: count
            };

        case CLEAR_MESSAGES:
            return {
                popupTitle:   null,
                messages:     [],
                popupCount: 0
            };

        default:
            return state;

    }

}

export default popupMessages;


// WEBPACK FOOTER //
// ./src/scripts/reusable/MessagePopup/redux/MessagePopup.reducers.js